import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import classNames from 'classnames';
import { FontAwesomeIconWrapper } from '@icon/fontawesome/FontAwesomeIconWrapper';
import { SkeletonLoader } from '@widget/loaders';
import { getFontAwesomeIcon, hasValue } from '@utils';
const AnalyticsCardBase = ({ icon, value, label, loading, small }) => {
    return (_jsxs("div", { className: classNames('uxpcore_analytics_card', { 'uxpcore_analytics_card--small': small }), children: [_jsxs("div", { className: "uxpcore_analytics_card__top", children: [_jsx("div", { className: "uxpcore_analytics_card__icon", children: loading ? (_jsx(SkeletonLoader, { width: "1rem", height: "1rem", additionalStyle: { borderRadius: '1rem' } })) : (_jsx(FontAwesomeIconWrapper, { icon: getFontAwesomeIcon(icon) })) }), _jsx("div", { className: "uxpcore_analytics_card__value", children: loading ? (_jsx(SkeletonLoader, { width: small ? '1rem' : '3rem' })) : (_jsx(_Fragment, { children: hasValue(value, true) ? (value) : (_jsx("div", { className: "uxpcore_analytics_card__value--novalue", children: "N/A" })) })) })] }), _jsx("div", { className: "uxpcore_analytics_card__bottom", children: _jsx("div", { className: "uxpcore_analytics_card__label", children: loading ? (_jsx(SkeletonLoader, { width: small ? '2rem' : '7rem', height: "1.3rem" })) : (label) }) })] }));
};
/**
 * @export
 * A compact analytics card component for displaying metrics with an icon, value, and label.
 *
 * @example
 * ```tsx
 * <AnalyticsCard
 *   icon="fas building"
 *   value={42}
 *   label="Total Buildings"
 * />
 * ```
 *
 * @example
 * ```tsx
 * <AnalyticsCard
 *   icon="fas users"
 *   value="1,234"
 *   label="Active Users"
 *   small={true}
 *   loading={false}
 * />
 * ```
 */
export const AnalyticsCard = memo(AnalyticsCardBase);
